export const environment = {
  production: false,
  apiUrl: 'https://dev.readyqual.com/ReadyQual',
  recaptcha: {
    siteKey: '6LfKNi0cAAAAACeYwFRY9_d_qjGhpiwYUo5gNW5-',
  },
};
